module.exports = __webpack_public_path__ + "media/images/icons/chevron-right-694fa0d22b23de52afc755ef0c7f7d81.svg";